export const environment = {
  production: false,
  existingCaseWorthyAPIURL:
    "https://dev.cw.caseworthy.net/CaseWorthy.API/",
  nextGenAccountsAPIURL: "https://dev.api.cwe.cw.caseworthy.net/account/services/v1/",
  nextGenFormsAPIURL: "https://dev.api.cwe.cw.caseworthy.net/forms/services/v1/",
  nextGenQueryAPIURL: "https://dev.api.cwe.cw.caseworthy.net/query-apbuilder/services/v1/",
  nextGenServerUrl: "https://dev.api.cwe.cw.caseworthy.net/"
}